import {
  SET_SELECTED_STATUS_ACTION,
  SET_SEARCH_TEXT_ACTION,
  SET_MUNICIPIOS_COLETA_ACTION,
  SET_ESTADOS_COLETA_ACTION,
  SET_PESO_ACTION,
  SET_VALOR_MERCADORIA_ACTION,
  SET_SELECTED_SORT,
  CLEAR_FILTERS,
  CLEAR_FILTERS_PROPERTY,
  SET_ESTADOS_ENTREGA_ACTION,
  SET_MUNICIPIOS_ENTREGA_ACTION,
} from './actions.type';
import {
  SET_SELECTED_STATUS,
  SET_SEARCH_TEXT,
  SET_MUNICIPIOS_COLETA,
  SET_ESTADOS_COLETA,
  SET_PESO,
  SET_VALOR_MERCADORIA,
  SET_MUNICIPIOS_ENTREGA,
  SET_ESTADOS_ENTREGA,
} from './mutations.type';

export default {
  [SET_SELECTED_STATUS_ACTION](context, status) {
    context.commit(SET_SELECTED_STATUS, status);
  },
  [SET_SEARCH_TEXT_ACTION](context, text) {
    context.commit(SET_SEARCH_TEXT, text);
  },
  [SET_MUNICIPIOS_COLETA_ACTION](context, text) {
    context.commit(SET_MUNICIPIOS_COLETA, text);
  },
  [SET_MUNICIPIOS_ENTREGA_ACTION](context, text) {
    context.commit(SET_MUNICIPIOS_ENTREGA, text);
  },
  [SET_ESTADOS_COLETA_ACTION](context, text) {
    context.commit(SET_ESTADOS_COLETA, text);
  },
  [SET_ESTADOS_ENTREGA_ACTION](context, text) {
    context.commit(SET_ESTADOS_ENTREGA, text);
  },
  [SET_PESO_ACTION](context, text) {
    context.commit(SET_PESO, text);
  },
  [SET_VALOR_MERCADORIA_ACTION](context, text) {
    context.commit(SET_VALOR_MERCADORIA, text);
  },
  [SET_SELECTED_SORT](context, text) {
    context.commit(SET_SELECTED_SORT, text);
  },
  [CLEAR_FILTERS](context) {
    context.commit(SET_VALOR_MERCADORIA, null);
    context.commit(SET_PESO, null);
    context.commit(SET_MUNICIPIOS_COLETA, []);
    context.commit(SET_ESTADOS_COLETA, []);
    context.commit(SET_MUNICIPIOS_ENTREGA, []);
    context.commit(SET_ESTADOS_ENTREGA, []);
  },
  [CLEAR_FILTERS_PROPERTY](context, property) {
    context.commit(property.property, property.defaultValue);
  },
};
